import { SortOrder } from 'kentico-cloud-delivery';
import Client from 'services/kenticoClient';
import { KENTICO_TYPES, SETTINGS } from 'common/consts/kentico';

class GeneralMeetingsService {
  /**
   * Fetch PressRoom News
   * Default parameters simlify getting data for most common cases.
   * @param { object } options
   *    { string } language (optional) one of predefined languages
   *    { number } limit (optional) Limit of items, for single response
   *    { number } page (optional) Which page of items to fetch e.g  page=2 gives items between 10 and 19 with limit 10
   *    { boolean } featured (optional) Queries for features items
   *    { number } publishYear (optional) Year extracted form publication date. If "null", query param is not set
   *    { string } category (optional) Category of selected filter
   * @returns { promise } Respolved to standard Kentico API response
   */
  async fetchGeneralMeetings({
    limit = SETTINGS.DEFAULT_LIMIT,
    page = 1,
    featured = false,
    publishYear = null,
    category = ''
  }) {
    const skip = (page - 1) * limit;
    const query = Client.items()
      .type(KENTICO_TYPES.GENERAL_MEETINGS)
      .orderParameter('elements.data_publikacji', SortOrder.desc)
      .limitParameter(limit)
      .skipParameter(skip);

    if (featured) {
      query.equalsFilter('elements.promowany__promowany[any]', 'tak');
    }

    if (category) {
      query.equalsFilter(
        'elements.kategoria_press_room[any]',
        category.toLowerCase()
      );
    }

    if (publishYear) {
      const dateFrom = `${publishYear}-01-01`;
      const dateTo = `${publishYear + 1}-01-01`;
      query.rangeFilter('elements.data_publikacji', dateFrom, dateTo);
    }

    return await query.toPromise();
  }

  /**
   * Fetch single PressRoom News by id
   * Default parameters simlify getting data for most common cases.
   * @param { string } id (required) id of the object
   *
   * @returns { promise } Respolved to standard Kentico API response
   */

  async getGeneralMeetingItemById(id) {
    const query = Client.items()
      .type(KENTICO_TYPES.GENERAL_MEETINGS)
      .equalsFilter('system.id', id);

    return query.toPromise();
  }

  async getGeneralMeetingItemBySlug(slug, lang) {
    const query = Client.kenticoItems()
      .type(KENTICO_TYPES.GENERAL_MEETINGS)
      .equalsFilter('elements.slug', slug);

    if (lang) {
      query.languageParameter(lang);
    }

    return query.toPromise();
  }
}

export default new GeneralMeetingsService();



// WEBPACK FOOTER //
// ./src/services/GeneralMeetings.service.js